export default __webpack_public_path__ + "static/media/c4c_1112x646.58dd568c.jpg";